import { Outlet } from 'react-router';
import { useNavigate } from "react-router";
import { useContext, useEffect, useState } from 'react';
import { useLocation } from "react-router";

import PlacesMenu from 'pages/places/menu/PlacesMenu';
import api from 'shared/topchef-api-places';
import { Place } from 'shared/topchef.types'
import Loading from 'pages/shared/loading/Loading'
import { NotificationContext } from 'shared/NotificationContext'
import { useErrorBoundary } from 'react-error-boundary';
import Footer from 'pages/shared/footer/Footer';
import UnknownUser from 'pages/shared/unknown-user/UnknownUser';

export type PlaceOutletContextType = [Place, (place: Place) => void];

const PlacesHome = () => {

  const [isReady, setReady] = useState<boolean>(false);
  const [getLoggedInPlace, setLoggedInPlace] = useState<Place | null>(null);
  const [getLoggedInPlaceFailed, setGetLoggedInPlaceFailed] = useState<boolean>(false);
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const navigate = useNavigate();
  const location = useLocation();

  const { showBoundary } = useErrorBoundary();

  useEffect(() => {

    if (getLoggedInPlaceFailed) {
      return;
    }

    async function getLoggedInPlaceDetails() {

      try {
        const place: Place = await api.getLoggedInPlace();
        setLoggedInPlace(place);
        setReady(true);
      } catch (error: any) { 
        setGetLoggedInPlaceFailed(true);
      } 

    }


    if (isReady === false) {
      getLoggedInPlaceDetails();
      return;
    }

    if (getLoggedInPlace?.firstConnection === true) {
      navigate('/places/my-account');
      return;
    }

    if (location.pathname === '/places') {
      navigate('/places/dashboard');
      return;
    }

  }, [navigate, location.pathname, getLoggedInPlaceFailed, getLoggedInPlace, isReady, triggerNotification, showBoundary]);

  
  if (getLoggedInPlaceFailed) {
    return (
      <UnknownUser />
    );
  }

  if (!isReady) {
    return (
      <Loading />
    );
  }



  return (
    <div className="d-flex" style={{height: "100vh"}}>
      <PlacesMenu loggedInPlace={getLoggedInPlace!} />
      <>
        <Outlet context={[getLoggedInPlace, setLoggedInPlace]} />
        <Footer />
      </>
    </div>    
  );

}

export default PlacesHome;
